// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/builds/2hHQnLx3/1/lf/aftersell/intradesk-frontend/apps/frontend/src/models/allSessionsModel';
import model_2 from '/builds/2hHQnLx3/1/lf/aftersell/intradesk-frontend/apps/frontend/src/models/emailTicketModel';
import model_3 from '/builds/2hHQnLx3/1/lf/aftersell/intradesk-frontend/apps/frontend/src/models/presetScriptModel';
import model_4 from '/builds/2hHQnLx3/1/lf/aftersell/intradesk-frontend/apps/frontend/src/models/saasTicketModel';
import model_5 from '/builds/2hHQnLx3/1/lf/aftersell/intradesk-frontend/apps/frontend/src/models/userModel';
import model_6 from '/builds/2hHQnLx3/1/lf/aftersell/intradesk-frontend/apps/frontend/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'allSessionsModel', model: model_1 },
model_2: { namespace: 'emailTicketModel', model: model_2 },
model_3: { namespace: 'presetScriptModel', model: model_3 },
model_4: { namespace: 'saasTicketModel', model: model_4 },
model_5: { namespace: 'userModel', model: model_5 },
model_6: { namespace: '@@initialState', model: model_6 },
} as const
